import { Dropdown, Menu, Button } from 'antd'
import { ChartCommon } from '../../common'
import './UserManagement.scss'

export const UserManagement = () => {
	const menu = (
		<Menu>
			<Menu.Item>1 day ago</Menu.Item>
			<Menu.Item>3 days ago</Menu.Item>
			<Menu.Item>7 days ago</Menu.Item>
			<Menu.Item>14 days ago</Menu.Item>
			<Menu.Item>1 month ago</Menu.Item>
		</Menu>
	)
	return (
		<div className="user-management-wrapper">
			<div className="single-chart-large">
				<div className="header">
					<div className="title">Traffic</div>
					<div className="actions">
						<Dropdown overlay={menu} placement="bottomCenter">
							<Button>Time</Button>
						</Dropdown>
					</div>
				</div>
				<div className="content">
					<ChartCommon chartID="chart-large-1" />
				</div>
			</div>
		</div>
	)
}
